import React,{useState} from 'react'
import {images} from '../../constants'
import { AppWrapper, MotionWrapper } from "../../wrapper";
import axios from 'axios'

import './footer.scss'

const Footer = () => {
  const [formData, setFormData] = useState({name: '',email: '',message: ''})
  const [isFormSubmitted, setIsFormSubmitted] = useState(false)
  const [loading, setLoading] = useState(false)
  const {name,email,message} = formData

  const handleChange = (e) => {
    const {name,value} = e.target
    setFormData({...formData, [name]: value})
  }

  const isFormEmpty = () =>{
    return !name.trim().length || !email.trim().length || !message.trim().length
  }
 
  const handleSubmit = async () => {
    if(isFormEmpty()){
      alert("Please fill in all fields.");
      return;
    }
    setLoading(true)
     await axios
    .post("https://getform.io/f/c7c87f01-f511-4659-84a5-e3a760622b9d", formData, 
    { headers: {'Accept': 'application/json'}})
     setLoading(false)
     setIsFormSubmitted(true)
  }

  return (
    <>
      <h2 id='contact' className='head-text'>Take A Coffee & Chat With Me</h2>
      <div className='app__footer-cards'>
        <div className='app__footer-card'>
          <img src={images.email} alt='email' />
          <a href='mailto:oluwaseyisamuel018@gmail.com' className='p-text'>Hello, Fadahunsi</a>
        </div>
        <div className='app__footer-card'>
          <img src={images.mobile} alt='mobile' />
          <a href='tel:+2347033715996' className='p-text'>+2347033715996</a>
        </div>
      </div>

      {!isFormSubmitted ?
      <div className='app__footer-form app__flex'>
        <div className='app__flex'>
          <input className='p-text'
           type='text'
            placeholder='Enter your name'
            name='name'
             value={name}
             onChange={handleChange} />
        </div>
        <div className='app__flex'>
          <input className='p-text'
           type='email'
            placeholder='Enter your email'
            name='email'
             value={email}
              onChange={handleChange} />
        </div>
        <div>
          <textarea className='p-text' placeholder='Enter your message'
          value={message}
          name='message'
          onChange={handleChange}
          />
        </div>
        <button type='button' className='p-text' onClick={handleSubmit}>{loading ? 'Sending': 'Send Message'}</button>
      </div> :   <div>
        <p  className='head-text'>Thank you for getting in touch</p>
      </div>
      }
    </>
  )
}

export default AppWrapper(
  MotionWrapper( Footer,'app__footer'),
  'footer',
  'app__whitebg'
  )
